export default __webpack_public_path__ + "static/media/dinesh_senghani_cropped.7eb50591.jpg";